"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RetryService = /** @class */ (function () {
    function RetryService() {
    }
    /**
    * Calculates retry attempt timeout in ms
    * @param attempt Index of the attempt to calculate increasing delay when retrying
    */
    RetryService.prototype.getRetryTimeout = function (attempt) {
        return Math.pow(2, attempt) * 100;
    };
    /**
     * Logs attempt in console.
     * This function is also used for testing in jasmine spy
     * @param attempt Index of attempt
     */
    RetryService.prototype.debugLogAttempt = function (attempt, retryTimeout) {
        console.warn("Attempt " + attempt + ": retrying in " + retryTimeout + "ms");
    };
    return RetryService;
}());
exports.RetryService = RetryService;
exports.retryService = new RetryService();
//# sourceMappingURL=retry-service.js.map


// WEBPACK FOOTER //
// ./node_modules/kentico-cloud-core/_commonjs/http/retry-service.js